import { Box, Tab, Tabs } from '@mui/material';
import '../../../CSS/private/PageContent_SideBar.css';
import SubTabBarItem from './SubTabBarItem';

function SubTabBar(props) {

  const router = props.router;
  const subTab = props.subTab;

  const handleChange = (e) => {
    props.setSubTab(e.target.id)
  }

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={subTab} onChange={handleChange}>
        {Object.keys(router).map((key => {
          return <Tab label={router[key].title} value={key} id={key} />
        }))}
      </Tabs>
    </Box>
  )
}

export default SubTabBar;